<template>
  <v-col cols="12">
    <v-tabs v-model="activeOrderTab">
      <v-tab v-for="item in items" :key="item.tab" :href="`#${item.tab}`">{{
        item.tab
      }}</v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeOrderTab" :touchless="false">
      <v-tab-item v-for="item in items" :key="item.tab" :value="item.tab">
        <div v-if="item.tab == 'Реклама'">
          <AdList></AdList>
        </div>
        <div v-if="item.tab == 'Отчеты'">
          <AdReport></AdReport>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </v-col>
</template>

<script>
export default {
  data: () => ({
    items: 
      [
        {  tab: "Реклама", content: "" , key: "goods"},
        {  tab: "Отчеты", content: "", key: "storage" },
      ]
  }),
  computed: {
    // stringValues: {
    //   get() {
    //     return this.$store.getters.STRING_VALUES;
    //   },
    // },
    // currentLanguage: {
    //   get() {
    //     return this.$store.getters.CURRENT_LANG;
    //   }
    // },
    activeOrderTab: {
      get: function () {
        return this.$store.getters.AD_ACTIVE_TAB;
      },
      set: function (newValue) {
        this.$store.commit("SET_AD_ACTIVE_TAB", newValue);
      },
    },
  },
};
</script>